import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-201720c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root hide-pc" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("注意報警報(気象庁)")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("閾値超過履歴")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.linkClass('/alerts'), "link"])
    }, [
      _createVNode(_component_router_link, { to: "/alerts" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.linkClass('/alerts/threashold'), "link"])
    }, [
      _createVNode(_component_router_link, { to: "/alerts/threashold" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ], 2)
  ]))
}